<template>
  <div class="element-test">
    <p>这是组件:{{msg}}</p>
    <p>{{count}}</p>
    <p>{{$store.state.count}}</p>
    <div>
      <el-button>默认按钮</el-button>
      <el-button type="primary" @click.native="add"> 主要按钮</el-button>
      <el-button type="success">成功按钮</el-button>
      <el-button type="info">信息按钮</el-button>
      <el-button type="warning">警告按钮</el-button>
      <el-button type="danger">危险按钮</el-button>
    </div>


    <div>
      <el-date-picker
        v-model="value6"
        type="datetimerange"
        align="right"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']">
      </el-date-picker>
    </div>


  </div>
</template>

<script>
  import store from '../vuex/store'
  import {mapGetters,mapState,mapMutations,mapActions} from 'vuex';
  export default {
    name: "ElementTest",
    data() {
      return {
        msg: "Element测试",
        value6: ''
      };
    },
    computed:{
      ...mapState(['count']),
      ...mapGetters(['countGetter'])
    },
    methods:{
      ...mapMutations(['add'])
    },
    store:store
  }
</script>

<style scoped>

  .element-test > * {
    margin-top: 20px;
  }



</style>



// WEBPACK FOOTER //
// src/components/ElementTest.vue